import { inject, Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../components/alert/alert.service';
import { ENV_TOKEN } from '../../app-module.token';
import { WindowFirma, WindowFirmaResponse } from './window-firma';
import { ElectronicDemandService } from '../../components/demanda/electronicDemand.service';
import { v4 as uuidv4 } from 'uuid';
import { Documents } from '../class/archivo.inteface';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface JsonAdicionales {
  userName: string;
  idUser: number;
  idOrganismo: number;
  IdSystem: number;
  IdPantalla: number;
  IdTransaction: string;
  tipoArchivo: number;
}

export interface Archivo {
  nombre: string;
  ext: string;
  jsonAdicionales: string;
}

export interface RootObject {
  archivos: Archivo[];
  jsonAdicionales: string;
}

export interface ArchivoResponse {
  id: string;
  nombre: string;
  nombreGenerado: string;
  ext: string;
  success: boolean;
}

export interface DataResponse {
  rutaArchivoOriginal: string;
  rutaArchivoOriginalWord: string | null;
  rutaP7M: string;
  rutaEvidencia: string;
  idProcess: string;
  archivos: ArchivoResponse[];
}

export interface RootResponse {
  data: DataResponse;
  success: boolean;
  message: string;
  transactionId: string | null;
}
@Injectable({
  providedIn: 'root',
})
export class FirmadorAvisoPrivacidadService {
  private authService = inject(AuthService);
  private constService: any;
  readonly environment = inject(ENV_TOKEN);
  private readonly windowFirma = new WindowFirma();
  private alertService = inject(AlertService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private http = inject(HttpClient);
  public paths!: DataResponse;

  constructor() {
    this.constService = this.environment;
  }

  // public async openWindowFirma(uuid: string, fileType: number): Promise<Documents[]> {
  //   if (uuid === "0") {
  //     uuid = uuidv4();
  //   }

  //   const paramsFilePath = {
  //     userName: this.authService.getUserName(),
  //     idUser: this.authService.getIdUser(),
  //     idOrganismo: this.authService.getIdOrgan(),
  //     IdSystem: 1,
  //     IdPantalla: 0,
  //     IdTransaction: uuid,
  //     tipoArchivo: fileType
  //   };

  //   const payload = {
  //     ...this.environment.signData,
  //     // endPointFilePath: "unc.api.filepath/api/files/UncFilesSign",
  //     endPointFilePath: "unc.api.filepath/api/Interconexion/Sign",
  //     tokenFilePath: '',
  //     paramsFilePath: JSON.stringify(paramsFilePath),
  //     idOperacion: uuid,
  //     idProceso: uuid,
  //     usuarioSistemaCliente: this.authService.getUserName(),
  //     sistemaCliente: this.environment.apiBaseUrl,
  //     paths: [
  //     {
  //       idPK: '891',
  //       id: '83705ea1-4498-4d31-8819-82607a441022',
  //       rutaOriginal:this.environment.documentoAPOrigen,
  //       rutaP7M:
  //         '\\\\10.100.126.204\\desa_fs\\FirmaElectronica\\UNC\\NoNotificados\\2026\\4\\21\\P7M\\',
  //       rutaEvidencia:this.environment.documentoAPEvidencia,
  //       canSign: true,
  //       transferencias: [
  //       ],
  //       label: null,
  //     },
  //   ],
  //   ocsp: false,
  //   login: false,
  //   instaSign: true,
  //   finishSign: false,
  //   };

  //   const signOrigin = new URL(this.environment.apiBaseUrl).origin;
  //   const signSrc = `${signOrigin}/Firmav2/sign`;

  //   try {
  //     const response: WindowFirmaResponse = await this.windowFirma.open({
  //       payload,
  //       src: signSrc,
  //       domain: signOrigin,
  //       blockerMessage: 'Procesando firma...',
  //       useBlocker: true,
  //       windowStyle: { width: 960, height: 640, center: true, features: { resizable: 'yes', scrollbars: 'yes' } }
  //     });

  //     if (response.payload.success) {
  //       const statusUpdated = await this.updateStatusSign(uuid);
  //       return statusUpdated ? await this.uploadFileList(uuid) : [];
  //     } else {
  //       this.alertService.error(response.payload.mensaje, { keepAfterRouteChange: false });
  //       return [];
  //     }
  //   } catch (error) {
  //     this.alertService.error(`Error: ${String(error)}`, { keepAfterRouteChange: false });
  //     return [];
  //   }
  // }
  public async openWindowFirma(uuid: string, fileType: number): Promise<Documents[]> {
    if (uuid === '0') {
      uuid = uuidv4();
    }

    const adicionales: JsonAdicionales = {
      userName: this.authService.getUserName(),
      idUser: this.authService.getIdUser(),
      idOrganismo: this.authService.getIdOrgan(),
      IdSystem: 1,
      IdPantalla: 0,
      IdTransaction: uuid,
      tipoArchivo: this.constService.TipoDoctos.TerminosyCondiciones,
    };

    const requestGetPaths: RootObject = {
      archivos: [
        {
          nombre: this.environment.archivoTerminosCondiciones,
          ext: 'pdf',
          jsonAdicionales: JSON.stringify(adicionales),
        },
      ],
      jsonAdicionales: JSON.stringify(adicionales),
    };

    const response = await this.GetPaths(requestGetPaths);
    if (response.success) {
      this.paths = response.data;
    } else {
      this.alertService.warn('No se encontro informacion de paths del archivo', {
        keepAfterRouteChange: false,
      });
      return [];
    }

    const paramsFilePath = {
      userName: this.authService.getUserName(),
      idUser: this.authService.getIdUser(),
      idOrganismo: this.authService.getIdOrgan(),
      IdSystem: 1,
      IdPantalla: 0,
      IdTransaction: uuid,
      tipoArchivo: fileType,
    };

    const payload = {
      ...this.environment.signData,
      endPointFilePath: 'unc.api.filepath/api/Interconexion/Sign',
      tokenFilePath: '',
      paramsFilePath: JSON.stringify(paramsFilePath),
      idOperacion: uuid,
      idProceso: uuid,
      usuarioSistemaCliente: this.authService.getUserName(),
      sistemaCliente: this.environment.apiBaseUrl,
      paths: [
        {
          idPK: this.paths.archivos[0].id,
          id: this.paths.archivos[0].id,
          rutaOriginal:
            this.paths.rutaArchivoOriginal + this.paths.archivos[0].nombreGenerado + '.pdf',
          rutaP7M: this.paths.rutaP7M,
          rutaEvidencia: this.paths.rutaEvidencia,
          canSign: true,
          label: 'TÉRMINOS Y CONDICIONES DE ADHESIÓN PARA LA INTERCONEXIÓN TECNOLÓGICA.pdf',
        },
      ],
      ocsp: false,
      login: false,
      instaSign: true,
      finishSign: false,
    };

    const signOrigin = new URL(this.environment.apiBaseUrlSite).origin;
    const siteFirma = this.environment.siteFirma;
    let signSrc: string;
    if (!siteFirma || siteFirma === '/') {
       signSrc = `${signOrigin}/sign`;
    }
    else{
       signSrc = `${signOrigin}/${siteFirma}/sign`;
    }

    try {
      const response: WindowFirmaResponse = await this.windowFirma.open({
        payload,
        src: signSrc,
        domain: signOrigin,
        blockerMessage: 'Procesando firma...',
        showForceCloseButton: false,
        forceCloseButtonText: 'Close 🍕',
        useBlocker: true,
        windowStyle: {
          width: 960,
          height: 640,
          center: true,
          features: { resizable: 'yes', scrollbars: 'yes' },
        },
      });

      if (response.payload.success) {
        const payload = {
          guid: uuid,
          nombreSesion: this.authService.getUserName(),
          documentos: response.payload.filesSign,
          idTransaction:this.authService.getIdAutoEnrolamiento()
        };
        const statusUpdated = await this.updateStatusSign(payload);
        return statusUpdated ? await this.uploadFileList(uuid) : [];
      } else {
        this.alertService.error(response.payload.mensaje, { keepAfterRouteChange: false });
        return await this.uploadFileList(uuid);
      }
    } catch (error) {
      this.alertService.error(`Error: ${String(error)}`, { keepAfterRouteChange: false });
      return await this.uploadFileList(uuid);
    }
  }

  private async updateStatusSign(payload: any): Promise<boolean> {
    try {
      const response: any = await firstValueFrom(this._service.updateStatusSign(payload));
      const isSuccess = (response?.success ?? response?.succcess) === true;
      const message = response?.message ?? 'No fue posible actualizar el estatus de firma.';

      if (!isSuccess) {
        this.alertService.error(message, { keepAfterRouteChange: false });
      }

      return isSuccess;
    } catch (httpError: any) {
      const message =
        httpError?.error?.message ??
        httpError?.message ??
        'Ocurrió un error al actualizar el estatus de firma.';
      this.alertService.error(message, { keepAfterRouteChange: false });
      return false;
    }
  }

  uploadFileList(uuid: string): Promise<Documents[]> {
    return this.GetDocumentosPantalla(uuid);
  }

  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {
    return new Promise((resolve) => {
      this._service.getDocumentosPantallaGuid(uuid).subscribe(
        (response: Documents[]) => {
          if (response?.length > 0) {
            resolve(response);
          } else {
            resolve([]);
          }
        },
        (error: any) => {
          this.alertService.error(error.message, { keepAfterRouteChange: false });
          resolve([]);
        },
      );
    });
  }

  public GetPaths(request: RootObject): Promise<RootResponse> {
    const signOrigin = new URL(this.environment.apiBaseUrlUNC).origin;
    const signComplete = `${signOrigin}/unc.api.filepath/api/Interconexion/Sign`;
    return firstValueFrom(this.http.post<RootResponse>(signComplete, request));
  }
}
